<template>
  <section class="company-quote-info">
    <template v-if="isRenew">
      <div
        v-if="item.plan_info.is_auto_quote"
        class="renew_tag">
        Auto Quote
      </div>
      <div
        v-else
        class="renew_tag">
        Manual Quote <span v-if="item.plan_info.is_same_pre_com">(Insurer Renew Terms)</span> 
      </div>
    </template>
    <template v-if="item.age_limit">
      <div
        v-for="(excessItem, excessIndex) in item.age_limit.items"
        v-show="excessIndex < 4"
        :key="'key' + excessIndex">
        <div class="table">
          <span
            class="table-title">{{ excessItem.sub_title? excessItem.sub_title: item.age_limit.title }}</span>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            v-show="subIndex < 4"
            :key="'subkey' + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span>{{ subItem.premium }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="item.excess">
      <div
        v-for="(excessItem, excessIndex) in item.excess.items"
        v-show="excessIndex < 4"
        :key="'excess' + excessIndex">
        <div class="table">
          <span
            class="table-title">{{ excessItem.sub_title? excessItem.sub_title: item.excess.title }}</span>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            v-show="subIndex < 4"
            :key="'subItem' + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span v-if="subItem.premium">{{ subItem.premium }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="item.coverage">
      <div
        v-for="(excessItem, excessIndex) in item.coverage.items"
        v-show="excessIndex < 4"
        :key="'coverage' + excessIndex">
        <div class="table">
          <span
            class="table-title">{{ excessItem.sub_title? excessItem.sub_title: item.coverage.title }}</span>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            v-show="subIndex < 4"
            :key="'coveragesubkey' + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span  v-if="subItem.type == 1">
              <i class="el-icon-check color-success icon-font" />
            </span>
            <span  v-else-if="subItem.type == 2">
              <i class="el-icon-close color-danger icon-font" />
            </span>
            <span v-else>{{ subItem.premium }}</span>
          </div>
        </div>
      </div>
    </template>
    <!--    <template v-if="item.special_clause">-->

    <!--        <div class="table">-->
    <!--          <span-->
    <!--              class="table-title">{{ item.special_clause.title }}</span>-->
    <!--          <div-->
    <!--              v-for="(subItem, subIndex) in item.special_clause.items"-->
    <!--              :key="'special_clause' + subIndex"-->
    <!--              class="tr">-->
    <!--            <span>{{ subItem.val }}</span>-->
    <!--          </div>-->

    <!--      </div>-->
    <!--    </template>-->
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'CompanyQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    classId: {
      type: [String, Number],
      default: '',
    },
    item: {
      type: Object,
      default: () => ({
        age_limit: {
          items: []
        },
        excess: {
          items: []
        },
        coverage: {
          items: []
        }
      }),
    },
    isRenew: {
      type: Boolean,
      default: false
    }
  },
  computed: {

  },
}
</script>
<style lang="scss" scoped>
// .flex {
//   justify-content: space-between;
.renew_tag{
  width: 299px;
  height: 18px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #6A737D;
}
  .table {
    flex: 1;
    margin-bottom: 10px;
    .icon-font{
      font-weight: 600;
    }
    .table-title {
        display: inline-block;
        padding-bottom: 2px;
        padding-left: 5px;
      font-size: 12px;
      font-weight: bold;
      color: #909399;
      line-height: 15px;
    }
    &:first-child {
      margin-right: 15px;
      .tr {
        span:first-child {
          width: 115px;
        }
      }
    }
    &:last-child {
      .tr {
        span:first-child {
          width: 130px;
        }
      }
    }
  }
// }
</style>
